'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var has = Object.prototype.hasOwnProperty;

var collection = {};

/**
 * Stores components for use in the core system to allow overrides of different components by name.
 * Also handles flipclock extensions from the local code
 */

var ComponentCollection = function () {
  function ComponentCollection() {
    (0, _classCallCheck3.default)(this, ComponentCollection);
  }

  (0, _createClass3.default)(ComponentCollection, null, [{
    key: 'setComponents',

    /**
     * Sets the component collection.
     * Takes both the defaults provided in the core and the overrides
     * given by the local code and merges them.
     *
     * @param {Array<React.Component>} defaults   The components given as defaults
     * @param {Array<React.Component>} components The components given as overrides
     * @public
     *
     * @return {ComponentCollection}
     */
    value: function setComponents(defaults, components) {
      collection = (0, _extends3.default)({}, defaults, components);

      return ComponentCollection;
    }

    /**
     * Get all components as a Key=>Value object with the values being display ready.
     *
     * @public
     *
     * @return {Array<React.Component>} Display ready react components
     */

  }, {
    key: 'getComponents',
    value: function getComponents() {
      return (0, _lodash.mapValues)(collection, function (component) {
        return component;
      });
    }

    /**
     * Get raw components as consructor functions
     *
     * @public
     *
     * @return {Array<React.Component>}
     */

  }, {
    key: 'getRawComponents',
    value: function getRawComponents() {
      return collection;
    }

    /**
     * Get a single raw component by name
     *
     * @param  {String} name
     * @param  {Function} fallback
     * @public
     *
     * @return {React.Component | Null}
     */

  }, {
    key: 'getComponent',
    value: function getComponent(name, fallback) {
      if (!has.call(collection, name)) {
        return fallback || null;
      }

      return collection[name];
    }

    /**
     * Convert component to raw
     *
     * @param  {React.Component} component
     * @public
     *
     * @return {React.Component}
     */

  }, {
    key: 'getRawComponent',
    value: function getRawComponent(component) {
      var raw = void 0;
      if (((typeof component === 'undefined' ? 'undefined' : (0, _typeof3.default)(component)) === 'object' || typeof component === 'function') && has.call(component, 'WrappedComponent')) {
        raw = component.WrappedComponent;
      } else if ((typeof component === 'undefined' ? 'undefined' : (0, _typeof3.default)(component)) === 'object' || typeof component === 'function') {
        raw = has.call(component, 'type') ? component.type : component;
      } else {
        raw = component;
      }

      return raw;
    }

    /**
     * Checks if ComponentCollection has any components
     *
     * @public
     *
     * @return {Boolean}
     */

  }, {
    key: 'hasComponents',
    value: function hasComponents() {
      return (0, _keys2.default)(collection).length > 0;
    }
  }]);
  return ComponentCollection;
}();

exports.default = ComponentCollection;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-utilities/build/ComponentCollection.js
// module id = 1146
// module chunks = 0